.dropdown {
  position: absolute;
  border: 1px solid var(--popover-border-color);
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  box-shadow: var(--popover-shadow, none);
  border-radius: var(--popover-radius, var(--mantine-radius-default));

  &:where([data-fixed]) {
    position: fixed;
  }

  &:focus {
    outline: none;
  }

  @mixin where-light {
    --popover-border-color: var(--mantine-color-gray-2);
    background-color: var(--mantine-color-white);
  }

  @mixin where-dark {
    --popover-border-color: var(--mantine-color-dark-4);
    background-color: var(--mantine-color-dark-6);
  }
}

.arrow {
  background-color: inherit;
  border: 1px solid var(--popover-border-color);
  z-index: 1;
}

.overlay {
  position: fixed;
  inset: 0;
}
